import {InternationalizationService} from '@app/core/services/internationalization.service';
import {BaseModel} from '@app/core/models/base.model';

export class ShiftStockBid extends BaseModel {
	public static readonly subjectType: string = 'App\\Models\\ShiftStockBid';
	public static readonly visibleCreated: string[] = [];
	public static readonly visibleUpdated: string[] = [];
	public static readonly dates: string[] = [];

	public static getTitle(tenantTZ: string, interService: InternationalizationService, activityDescription): string {
		switch (activityDescription) {
			case 'created':
				return interService.translate.instant('ACTIVITY_LOG.CREATED_BID_ON_THE_SHIFT');
			case 'updated':
				return interService.translate.instant('ACTIVITY_LOG.UPDATED_BID_ON_THE_SHIFT');
			case 'deleted':
				return interService.translate.instant('ACTIVITY_LOG.DELETED_BID_ON_THE_SHIFT');
		}

		return '';
	}

	constructor(tenantTZ: string, interService: InternationalizationService) {
		super(tenantTZ, interService);
	}

	public deserialize(input: any): any {
		Object.assign(this, input);

		return this;
	}
}
